<iframe
    id="webview-container"
    [src]="cleanURL(link)"
></iframe>
